var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-dashboards',{attrs:{"titleSmartsheet":"Pmgd","typeSmartsheet":_vm.SMARTSHEET_TYPES.pmgd}})
}
var staticRenderFns = []

export { render, staticRenderFns }